import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import api from "../api";
import EventStatsCard from "../components/EventStatsCard";
import EventPhotosStats from "../components/EventPhotosStats";
import SocialStats from "../components/SocialStats";
import ActivityCard from "../components/ActivityCard";
import MyEventsSummary from "../components/MyEventsSummary";
import { aggregateStats } from "../utils/Stats";


const HomeAdmin = ({ user }) => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [aggregates, setAggregates] = useState({
    totalStats: {},
    photoStats: {},
    socialStats: {},
  });

  //   first hour of the current day
  const currentDate = new Date();
  const dateMinus24h = new Date(currentDate.getTime() - 24 * 60 * 60 * 1000);
  function toMysqlDatetime(date) {
  const pad = (n) => (n < 10 ? '0' + n : n);
    return (
      date.getFullYear() + '-' +
      pad(date.getMonth() + 1) + '-' +
      pad(date.getDate()) + ' ' +
      pad(date.getHours()) + ':' +
      pad(date.getMinutes()) + ':' +
      pad(date.getSeconds())
    );
  }

  // last -24 hours of the current day
  const startDateTime = toMysqlDatetime(dateMinus24h);
  const endDateTime = toMysqlDatetime(currentDate);


  useEffect(() => {
    const fetchEvents = async () => {
      setLoading(true);
      try {
        const res = await api.get(`/events?user_id=${user.user_id}`, {
          withCredentials: true,
        });
        setEvents(res.data || []);
        const { totalStats, photoStats, socialStats } = aggregateStats(res.data || []);
        setAggregates({ totalStats, photoStats, socialStats });
      } catch (err) {
        console.error("Error fetching events:", err);
      } finally {
        setLoading(false);
      }
    };

    if (user?.user_id) fetchEvents();
  }, [user]);

  if (loading) {
    return <div className="text-center py-5 text-muted">Loading dashboard...</div>;
  }

  return (
    <Container className="mt-3">
      {/* <h4 className="fw-bold text-secondary mb-4">Dashboard Overview</h4> */}
      <Row>
        <Col md={6} className="mb-3">
          <MyEventsSummary events={events}/>
        </Col>
        <Col md={6} className="mb-3">
          <EventPhotosStats storage={{ ...aggregates.photoStats }} />
        </Col>
        <Col md={6} className="mb-3">
          <EventStatsCard stats={aggregates.totalStats} />
        </Col>
        <Col md={12} className="mb-3">
          <SocialStats stats={aggregates.socialStats} />
        </Col>
        <Col md={12} className="mb-3">
          <ActivityCard userId={1} startDateTime={startDateTime} endDateTime={endDateTime} />
        </Col>

      </Row>
    </Container>
  );
};

export default HomeAdmin;
